import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { usCurrency } from "../../../../../utils";
import { isEmpty } from "lodash";
import { SliderPanel, Link } from "../../../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import PayrollTransactionDetails from "../FundingSliders/PayrollTransactionDetails";
import { useRequest } from "../../../../../abstracts";
import { getFundingDetailsByFile } from "../../../../../services";

const columns = [
  {
    label: "Plan Name",
    className: "column-file-plan-name",
  },
  {
    label: "Plan ID",
    className: "column-file-plan-id",
  },
  {
    label: "Employees",
    className: "column-file-employee",
  },
  {
    label: "Total funding",
    className: "column-file-total-funding",
  },
  // {
  //   label: "Contribution details",
  //   className: "column-file-source-details",
  // },
];

const DisplayFileLevel = ({ payrollId }) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const { response: payrollFile, loading: isLoading } = useRequest({
    method: getFundingDetailsByFile,
    payload: payrollId,
    defaultResponse: {},
  });
  const payrollFileData = !isEmpty(payrollFile) ? [payrollFile] : [];

  const showPopup = () => {
    setModalOpen(true);
  };

  return (
    <div className="payroll-file-columns">
      {!isEmpty(payrollFileData) ? (
        <>
          <div className="d-flex justify-content-space-between align-items-center ">
            {columns.map((item, index) => {
              return (
                <p className={`ft-12 grey-text ${item.className}`}>
                  {item.label}
                </p>
              );
            })}
          </div>
          <>
            {payrollFileData.map((data, index) => (
              <>
                <div className="payroll-file-table-view payroll-file-card">
                  <div className="d-flex justify-content-between align-items-center align-self-center">
                    {data.planName && data.planName.length > 30 ? (
                      <OverlayTrigger
                        overlay={<Tooltip>{data.planName}</Tooltip>}
                      >
                        <p className="ft-14 black-text column-file-plan-name">
                          {(data.planName || "").slice(0, 30)}...
                        </p>
                      </OverlayTrigger>
                    ) : (
                      <p className="ft-14 black-text column-file-plan-name">
                        {data.planName === "Multiple"
                          ? "Multiple plans"
                          : data.planName}
                      </p>
                    )}
                    <p className="ft-14 black-text column-file-plan-id">
                      {data.rkPlanNumber === "Multiple"
                        ? "Multiple plan ID's"
                        : data.rkPlanNumber}
                    </p>
                    <p className="ft-14 black-text column-file-employee">
                      {data.employeesCount}
                    </p>
                    <p className="ft-14 black-text font-weight-500 column-file-total-funding">
                      {usCurrency(data.totalFunding)}
                    </p>
                    {/* <Link
                      className="ft-14 link-text mt-0 column-file-source-details"
                      onClick={() => {
                        showPopup();
                      }}
                    >
                      View
                    </Link> */}
                  </div>
                </div>
              </>
            ))}
          </>
        </>
      ) : (
        <div>No data</div>
      )}

      <SliderPanel
        isOpen={isModalOpen}
        size="30"
        showCancel={false}
        backdropClicked={() => setModalOpen(false)}
      >
        <div className="d-flex justify-content-between">
          <div className="ft-14 font-weight-500">Contribution details</div>
          <div>
            <FontAwesomeIcon
              icon={faTimes}
              size="18px"
              color="#828282"
              onClick={() => setModalOpen(false)}
              className="pointer"
            />
          </div>
        </div>
        <div className="border-top" />
        <PayrollTransactionDetails fileId={payrollId} toggle={true} />
      </SliderPanel>
    </div>
  );
};

export default DisplayFileLevel;
